import { render, staticRenderFns } from "./PersonBasic.vue?vue&type=template&id=1165ec12&scoped=true&"
import script from "./PersonBasic.vue?vue&type=script&lang=ts&"
export * from "./PersonBasic.vue?vue&type=script&lang=ts&"
import style0 from "./PersonBasic.vue?vue&type=style&index=0&id=1165ec12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1165ec12",
  null
  
)

export default component.exports